import React from "react";
import { parseISO } from "date-fns";

const options = { weekday: "short", month: "short", day: "numeric", year: "numeric" };

export default function CheckinFormContent({ value, today }) {
  if (!value || !value.tenancyDetails) return null;

  const { tenancyDetails, customersDetails } = value;

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        color: "#222",
        lineHeight: 1.6,
        fontSize: "14px",
        paddingLeft:"2%"
      }}
    >
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <strong style={{ fontSize: "18px" }}>Tidy Inn LLC</strong>
        <div>1601 George Jenkins Blvd</div>
        <div>Lakeland Fl. 33815</div>
        <div>863-825-5007</div>
      </div>

      {/* Guest Info */}
      <div>
        {customersDetails.map((c, index) => (
          <div key={index} style={{ marginBottom: "6px" }}>
            <div style={{paddingLeft:"20%",}}>
              Guest Name(s): <strong>{c.fname + " " + c.lname}</strong>
            </div>
            <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                margin: "4px 0",

                rowGap: "6px",
                paddingLeft:"20%",
                paddingRight:"20%"
            }}
            >
            <div>
                <a>
                Phone Number:{" "}
                <strong>{c.phone}</strong>
                </a>
            </div>
            <div>
                <a>
                Email Address:{" "}
                <strong>{c.email}</strong>
                </a>
            </div>
            </div>
            
        
          </div>
        ))}
      </div>

      {/* Tenancy Info */}
      {/* Room / Tenancy Type */}
<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",

    rowGap: "6px",
    margin: "10px 0",
    paddingLeft:"20%",
    paddingRight:"20%"
  }}
>
  <div>
    <a>
      Room#:{" "}
      <strong style={{ fontSize: "1.1em" }}>{tenancyDetails.roomid}</strong>
    </a>
  </div>
  <div>
    <a>
      Tenancy Type:{" "}
      <strong style={{ fontSize: "1.1em" }}>Transient</strong>
    </a>
  </div>
</div>

{/* Checkin / Checkout */}
<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",

    rowGap: "6px",
    marginBottom: "8px",
    paddingLeft:"20%",
    paddingRight:"20%"
  }}
>
  <div>
    <a>
      Checkin:{" "}
      <strong>
        {parseISO(tenancyDetails.checkin).toLocaleDateString(
          "en-us",
          options
        )}
      </strong>
    </a>
  </div>
  <div>
    <a>
      Checkout:{" "}
      <strong>
        {parseISO(tenancyDetails.checkout).toLocaleDateString(
          "en-us",
          options
        )}
      </strong>
    </a>
  </div>
</div>

{/* Rate / Deposit */}
<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "6px",
    marginBottom: "8px",
    paddingLeft:"20%",
    paddingRight:"20%"
  }}
>
  <div>
    <a>
      Rate:{" "}
      <strong>
        ${tenancyDetails.rate} ({tenancyDetails.rentalType})
      </strong>
    </a>
  </div>
  <div>
    <a>
      Room Deposit: <strong>${tenancyDetails.deposit}</strong>
    </a>
  </div>
</div>

{/* Adults / Children */}
<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    // columnGap: "20px",
    rowGap: "6px",
    marginBottom: "15px",
    paddingLeft:"20%",
    paddingRight:"20%"

  }}
>
  <div>
    <a>
      Number of Adults: <strong>{tenancyDetails.adults}</strong>
    </a>
  </div>
  <div>
    <a>
      Number of Children: <strong>{tenancyDetails.children}</strong>
    </a>
  </div>
</div>


      {/* Terms */}
      <h4
  style={{
    marginTop: "15px",
    marginBottom: "10px",
    textAlign: "center"
  }}
><u>
  Terms and Conditions</u>
</h4>

<ul
  style={{
    marginLeft: "5%",
    marginRight: "7%",
    textAlign: "left",
  }}
>
  <li>
    This is an extended stay motel and stay is temporary. This is not your
    primary residence. You are a <strong>transient occupant.</strong>
  </li>
  <li>You can not use the motel address as your personal or business address.</li>
  <li>Check-out time is at 11:00 A.M.</li>
  <li>
    If you would like to occupy the premises for longer, you must speak with
    someone at the front desk and come to a written agreement. If no agreement
    is reached, you must vacate by the check-out time and date.
  </li>
  <li>
    Guests will be held responsible for any loss or damage done to a room during
    their stay.
  </li>
  <li>Motel Management is not responsible for your personal belongings or valuables.</li>
  <li>
    We check toilets for clogging issues before your stay. If the toilet is
    clogged during your stay, a sum of $250 per plumber call will be charged.
    Guest will be responsible for any additional charges if applicable.
  </li>
  <li>The room you are assigned MUST be left in the same condition in which you rented it.</li>
  <li>No tampering with or removal of smoke detectors.</li>
  <li>Speed Limit 5 MPH. Careful driving is expected.</li>
</ul>


      <p>
        By signing you acknowledge you have read all of the above terms and
        conditions
      </p>
      <a><strong>Guest Signature: </strong></a>
      <hr />
      <a><strong>Date: {today}</strong></a>
      <hr />

      {/* House Rules */}
      <h4 style={{ marginTop: "20px", textAlign: "center" }}><u>TIDY INN HOUSE RULES</u></h4>
      <ul style={{ marginLeft: "5%", marginRight: "7%", textAlign: "left" }}>
        <li>
          <strong>No Pets.</strong> If any pets are found, the tenant agrees to
          pay a fine of $500 and move out immediately. If damages are more than
          $500, the tenant agrees to pay the attorney and legal fees.
        </li>
        <li>
          <strong>No smoking allowed in the rooms.</strong> You will be asked to
          leave immediately and legal action will follow if we find you smoking
          inside the room. Quiet hours are from 9pm - 6am.
        </li>
        <li>
          <strong>Cleanliness:</strong> We appreciate you keeping the rooms
          clean. We only allow clean tenants. You will be requested to leave if
          you keep the room dirty. Management reserves the right to decide.
        </li>
        <li><strong>No loud music.</strong></li>
        <li>
          <strong>No loud arguments.</strong> Our guests like our place quiet.
          You will be asked to leave if you argue loud.
        </li>
        <li>
          <strong>No additional guests / human trafficking / drugs.</strong> If
          we find traffic to the room, you will be asked to leave immediately.
          We work with police to stop human trafficking and drugs.
        </li>
        <li>
          <strong>Zero tolerance for slamming doors.</strong> You will be asked
          to leave immediately and legal action may follow if there are damages.
        </li>
        <li>
          <strong>Courtesy:</strong> Please be courteous to the employees. We
          can discuss and resolve problems without raising the voice.
        </li>
        <li>
          <strong>Inspections:</strong> Management will do inspections for
          smoking, cleanliness, presence of pets or any safety concerns.
        </li>
      </ul>

      <p>
        I agree with the house rules. I agree to check out immediately if
        management decides that rules are broken. I will be responsible for any
        damages / court charges caused.
      </p>
      <a><strong>Guest Signature: </strong></a>
      <hr />
      <a><strong>Date: {today}</strong></a>
      <hr />

      {/* Footer */}
      <div style={{ textAlign: "center", marginTop: "15px" }}>
        <strong>Tidy Inn LLC</strong>
        <div>1601 George Jenkins Blvd</div>
        <div>Lakeland Fl. 33815</div>
        <div>863-825-5007</div>
      </div>

      <div style={{ marginTop: "10px" }}>
        <a>
          Room#: <strong>{tenancyDetails.roomid}</strong>
        </a>
        <div className="info">
          {customersDetails.map((c, index) => (
            <div key={index}>
              <a>
                Guest Name(s): <strong>{c.fname + " " + c.lname}</strong>
              </a>
            </div>
          ))}
        </div>
      </div>

      <p style={{ marginTop: "10px" }}>
        I understand and agree that this will not be my primary residence. I
        have a permanent address somewhere else and agree and understand that
        this will be a transient occupancy.
      </p>

      <p>
        I agree to check out on{" "}
        <strong>{tenancyDetails.checkout}</strong> before 11:00 am EST. I will
        remove all my stuff, leave the room in a clean condition, and return the
        keys to the manager at the front desk as well.
      </p>

      <a><strong>Guest Signature: </strong></a>
      <hr />
      <a><strong>Date: {today}</strong></a>
      <hr />
    </div>
  );
}
